import styled from 'styled-components';

export const SisIdCellWrapper = styled.div`

`;
